@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.item-to-merge {
  border: 1px solid transparent;
  border-bottom: solid 1px @customer-page--item-merge--border-color;
  cursor: move;
  margin-bottom: 8px;
  padding: 4px;
}

.survivor-item {
  background-color: @customer-page--item--background-color;
  border-color: @customer-page--item--border-color;
  color: @customer-page--item--text-color;
}

.customer-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.surviving-item-message {
  text-align: center;
  font-weight: 700;
}

.logo-wrapper {
  height: 16px;
  width: 16px;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;

  > svg {
    height: 16px;
    width: 16px;
  }
}

.xmark {
  transform: scale(0.27);
  cursor: pointer;
}
